<h2 mat-dialog-title>Editar Morosidad</h2>
<mat-dialog-content class="d-flex flex-column mt-3" [formGroup]="modificationForm">
  <mat-form-field class="mt-2" appearance="outline">
    <mat-label>Rut Creditor</mat-label>
    <input matInput placeholder="" value="" formControlName="creditor_rut">
  </mat-form-field>
  <mat-form-field class="" appearance="outline">
    <mat-label>Monto</mat-label>
    <input matInput placeholder="" value="" type="number" formControlName="amount" (keypress)="validateNumber($event)">
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-end mx-3">
    <button mat-button color="primary" (click)="onNoClick()">Cancelar</button>
    <button mat-flat-button color="primary" cdkFocusInitial (click)="onModify()">Modificar</button>
</mat-dialog-actions>
